module.exports = __webpack_public_path__ + "static/media/MeasuringOilandWaterInflow.bbb7ac93.pdf";